import { render, staticRenderFns } from "./BaseFeedFormula.vue?vue&type=template&id=fc031222"
import script from "./BaseFeedFormula.vue?vue&type=script&lang=js"
export * from "./BaseFeedFormula.vue?vue&type=script&lang=js"
import style0 from "./BaseFeedFormula.vue?vue&type=style&index=0&id=fc031222&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports